import React, { useMemo } from 'react'

import { MessageBanner, MessageBannerType } from '@amzn/stencil-react-components/message-banner'
import { IconCheckLarge, IconDisabledLarge } from '@amzn/stencil-react-icons'

import { ApprovalStatus } from 'src/models/dto/ApprovalStatus'

// TODO AA-17327 refactor the props
export function ModuleApprovalMessage(props: {
    approvalStatus: ApprovalStatus
    reviewers: string[]
}) {
    const { approvalStatus, reviewers } = props
    return useMemo(() => {
        const icon =
            approvalStatus === ApprovalStatus.Approved ? (
                <IconCheckLarge title='' aria-hidden />
            ) : (
                <IconDisabledLarge title='' aria-hidden />
            )

        return (
            <MessageBanner
                dataTestId='module-approval'
                data-approval-status={approvalStatus}
                icon={icon}
                type={
                    approvalStatus === ApprovalStatus.Approved
                        ? MessageBannerType.Success
                        : MessageBannerType.Warning
                }
            >
                {approvalStatus === ApprovalStatus.Approved ? 'Approved ' : 'Approval Revoked '}
                by {reviewers.join(', ')}.
            </MessageBanner>
        )
    }, [reviewers, approvalStatus])
}
